(function() {

    'use strict';

    /**
     * @module Plugins
     *
     * Responsible for displaying the HD button for videos which have HD version in SAPO Videos.
     *
     * Switches between HD and SD videos on demand.
     *
     * Makes use of the metadata_changed message to assert if video has high quality version or not.
     *
     * @namespace sv_quality
     */



    var _    = SAPO.Project.Video._,
        Css  = SAPO.Dom.Css;




    var plugin = function(vc, ui, pub, pubD, v, setOption) {
        this._vc        = vc;
        this._ui        = ui;
        this._pub       = pub;
        this._pubD      = pubD;
        this._v         = v;
        this._setOption = setOption;

        this._inHD      = undefined;
        this._btnEl     = undefined;
        this._md        = undefined;

        this._vc.subscribe('button_activated metadata_changed', undefined, this);

        this._btnEl = this._ui.addButton('quality', 'right');
        this._ui.hideButton('quality');
    };

    plugin.prototype = {

        _name: plugin._name = 'sv_quality',

        on_button_activated: function(mt, id) {
            if (id.indexOf('quality-') !== 0) { return; }
            this._setQuality( !this._inHD );
        },

        on_metadata_changed: function(mt, md) {
            this._md = md;

            this._inHD = this._vc.isHD();

            //console.log('METADATACHANGED. Video quality is ', (this._inHD ? 'HD': 'SD') );

            var el = this._btnEl;

            if (md.isAd || md.isLive || !md.hasHD || this._vc.getOption('quality')) {
                this._ui.hideButton('quality');
            }
            else {
                this._ui.showButton('quality');


                if (el) {
                    el.title = _('qualityTitle');
                }
                else {
                    el = this._btnEl; // feching previous button
                }

                el.removeAttribute('disabled', '');

                Css.removeClassNamesStartingWith(
                    el,
                    'quality-',
                    this._inHD ? 'hd': 'sd'
                );
            }
        },

        _setQuality: function(isHd) {
            //console.log('SETTING QUALITY ', (isHd ? 'HD' : 'SD') );

            this._setOption('startTime', this._vc.getCurrentTime());

            Css.removeClassName(this._ui._els.player, 'is-new-video');

            this._btnEl.setAttribute('disabled', '');

            this._vc.load({
                requestURL: this._md.requestURL,
                autoplay:   true,
                quality:    (isHd?'hd':'sd')
            });
        }

    };

    SAPO.Project.Video.Controllers._plugins.push(plugin);

})(undefined);
